// --------------------------------------------------------------------------
// Top level loader
// --------------------------------------------------------------------------

import React from 'react';
import ReactDOM from 'react-dom';
import './styles.css';

// --------------------------------------------------------------------------

import WineEventsScanner from './components/wine-scanner-ui';

// --------------------------------------------------------------------------

const rootElement = document.getElementById("bsRoot");

function param(name,defaultValue) {
    let ele = rootElement.attributes[name];
    if(ele==null) return defaultValue;
    return ele.value;
}

let mappingDataURL = param('mappingdataurl', null);
let APIURLprefix = param('apiurlprefix', null);

// this gets prepended to thumbnail urls and product URL and tasting notes URL - should be blank or a protocol+domain
let baseURL = param('baseurl',null);

// baseURL / site root relative URLs of product URL and tasting notes URL
let productURL = param('producturl',null);
let tastingNotesURL = param('tastingnotesurl',null);

function App() {
    return (
        <WineEventsScanner
            
            mappingDataURL = { mappingDataURL }
            APIURLprefix = { APIURLprefix }
            
            baseURL = { baseURL }    
            productURL = { productURL }
            tastingNotesURL = { tastingNotesURL }
            />
    );
}

ReactDOM.render(<App />, rootElement);
